"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayType_1 = require("../Store/Constants/ArrayType");
var createArrayProxy_1 = require("../Store/createArrayProxy");
var createObjectProxy_1 = require("../Store/createObjectProxy");
var EXPONENT = 2;
/**
 * Determines what type the array is based on the `bestGuessItemValue`,
 * which is either the first item in the array, or a provided value
 * if empty.
 */
var identifyArrayProxyType = function (bestGuessItemValue) {
    var constructor = bestGuessItemValue
        ? bestGuessItemValue.constructor
        : null;
    var isDomNode = typeof window !== 'undefined' && bestGuessItemValue instanceof Node;
    return !bestGuessItemValue ||
        typeof bestGuessItemValue !== 'object' ||
        isDomNode
        ? ArrayType_1.default.PRIMATIVE
        : Array.isArray(bestGuessItemValue)
            ? ArrayType_1.default.ARRAY
            : constructor !== Object
                ? ArrayType_1.default.STATIC_OBJECT
                : ArrayType_1.default.DYNAMIC_OBJECT;
};
/**
 * Ensures new index "portals" are added after any mutation
 * that may cause an increase in the underlying array's length.
 *
 * Returns the total number of portals after spawning.
 *
 * An optional `itemValue` may be passed if performing a
 * direct index assignment via a "filler", incase the array is
 * empty and in order to duck-type the proxy schema.
 */
var spawnIndexPortals = function (_a, lastPortalCount, _b) {
    // Obtain a reference to the current underlying array
    var store = _a.store, path = _a.path, proxyNode = _a.proxyNode;
    var _c = _b === void 0 ? {} : _b, itemValue = _c.itemValue, assignmentIndex = _c.assignmentIndex, prepopulatedArray = _c.prepopulatedArray;
    var proxy = proxyNode.proxy;
    var arr = prepopulatedArray || store.readPropertyValue(path, true);
    assignmentIndex = assignmentIndex || -1;
    // If the arr is not empty and at least `arr.length` portals + 1 have
    // been spawned, abort and return an unchanged count
    if (arr.length > 0 &&
        assignmentIndex <= arr.length &&
        lastPortalCount > arr.length)
        return lastPortalCount;
    // Attempt to infer the array type by duck-typing the first value if
    // not empty, else fall back to the `itemValue` if passed.
    var bestGuessItemValue = arr[0] !== undefined ? arr[0] : itemValue;
    if (proxy._isUnknownType) {
        proxy._type = identifyArrayProxyType(bestGuessItemValue);
    }
    var targetPortalCount = lastPortalCount || arr.length || 1;
    // Exponentially increase the number of portals whenever
    // we exhuast the current set.
    do
        targetPortalCount = targetPortalCount *= EXPONENT;
    while (targetPortalCount < arr.length);
    var _loop_1 = function (i) {
        var itemPath = __spreadArrays(path, [i.toString()]);
        if (proxy._hasProxyableType) {
            // If the contents of the array are "proxyable", create the
            // appropriate proxy type at this index.
            if (!proxyNode.children)
                proxyNode.children = {};
            // Only create a proxy at the portal if it is a statically typed array
            // and the shape can be safely inferred, or it is a dynamic object array,
            // and a dynamic object already exists at the index that an initial proxy can be
            // built from.
            if (proxy._isStaticType || arr[i] !== undefined) {
                proxyNode.children[i] = proxy._isArrayType
                    ? createArrayProxy_1.default(store, arr[i] || arr[0], itemPath)
                    : createObjectProxy_1.default(store, proxy._isStaticType ? bestGuessItemValue : arr[i], itemPath);
            }
        }
        // Create a portal at the index
        Object.defineProperty(proxy, i, {
            get: function () {
                return store.readPropertyValue(itemPath, false, proxy._isDynamicType);
            },
            set: function (value) { return store.writePropertyValue(itemPath, value); }
        });
    };
    for (var i = lastPortalCount; i < targetPortalCount; i++) {
        _loop_1(i);
    }
    return targetPortalCount;
};
exports.default = spawnIndexPortals;
//# sourceMappingURL=spawnIndexPortals.js.map